// Mock data for JurisGo Platform

export const mockData = {
  logo: `${process.env.PUBLIC_URL || ''}/jurisgo-logo.jpg`,
  razorpayLink: "https://pages.razorpay.com/jurisgo",
  whatsappGroup: "https://chat.whatsapp.com/JEsdqoYisesDUioAKKyHsx",
  
  // Corporate Services
  corporateServices: [
    {
      id: "lpo",
      title: "Legal Process Outsourcing for Law Firms",
      subtitle: "Personal Injury Paralegal Support Services",
      description: "Partner with JurisGo to access highly trained Personal Injury paralegals ready to support your law firm's PI operations. Reduce costs, increase efficiency, and maintain quality with our specialized Personal Injury LPO solutions.",
      icon: "briefcase",
      benefits: [
        "Cost Reduction: Save up to 60% on operational costs",
        "Scalability: Flexible team size based on your needs",
        "Quality Assurance: Trained and certified PI paralegals",
        "Quick Turnaround: Fast onboarding and deployment",
        "Specialized Expertise: Personal Injury focused support",
        "24/7 Availability: Round-the-clock support across time zones"
      ],
      services: [
        "Client Intake",
        "Medical Record Summaries",
        "Evidence Tracker Logs",
        "Demand Valuation Sheets",
        "Demand Letters",
        "Disclosures",
        "Form Interrogatories",
        "RFPD (Requests for Production of Documents)"
      ]
    },
    {
      id: "training",
      title: "Paralegal Corporate Training Programs",
      subtitle: "Remote Personal Injury Paralegal Training for Your Legal Team",
      description: "Transform your in-house legal team with our specialized Personal Injury paralegal training program. Delivered 100% online/remote, our training enhances productivity in PI case management, ensures compliance, and builds specialized expertise in Personal Injury law.",
      icon: "graduation-cap",
      benefits: [
        "Specialized Curriculum: Personal Injury focused training",
        "Expert Trainers: Industry professionals with US PI law firm experience",
        "Flexible Delivery: 100% Remote/Online training",
        "Certification: Recognized completion certificates",
        "Ongoing Support: Post-training mentorship and resources",
        "ROI Focused: Measurable improvement in PI case handling"
      ],
      services: [
        "Personal Injury Case Management Training",
        "Medical Records Review & Analysis",
        "Demand Letter Drafting",
        "Client Intake & Communication Skills",
        "Evidence & Document Management",
        "Legal Research for PI Cases",
        "Settlement Negotiations Support",
        "PI Case Documentation & Filing"
      ]
    },
    {
      id: "placement",
      title: "Placement & Hiring Solutions for Corporates",
      subtitle: "Access Top-Tier Paralegal Talent for Your Organization",
      description: "Streamline your hiring process with JurisGo's curated talent pool. We connect you with pre-vetted, trained paralegals who are ready to contribute from day one. Whether you need full-time, part-time, or project-based support, we have the right talent.",
      icon: "users",
      benefits: [
        "Pre-Vetted Candidates: Thoroughly screened and assessed",
        "Fast Placement: Reduce hiring time by up to 70%",
        "Quality Guarantee: Replacement guarantee for unsatisfactory hires",
        "Cost-Effective: No lengthy recruitment processes",
        "Diverse Talent Pool: Access to specialized expertise",
        "Ongoing Support: Post-placement check-ins and support"
      ],
      services: [
        "Permanent Placement Services",
        "Contract & Temporary Staffing",
        "Project-Based Hiring",
        "Bulk Recruitment Solutions",
        "Skill Assessment & Testing",
        "Background Verification",
        "Salary Benchmarking & Consulting",
        "Retention & Engagement Support"
      ]
    },
    {
      id: "legal-drafting",
      title: "Legal Drafting Services for Indian Lawyers",
      subtitle: "Professional Legal Drafting at Affordable Rates",
      description: "Expert legal drafting services for Indian lawyers and law firms. Get professionally drafted legal documents with quick turnaround times. Try our free trial draft and experience quality legal drafting with our monthly subscription model.",
      icon: "file-text",
      benefits: [
        "Affordable Pricing: Cost-effective monthly subscription model",
        "Quick Turnaround: 3-4 days delivery time",
        "Free Trial Draft: Try our services risk-free",
        "Expert Drafters: Experienced legal professionals",
        "Quality Assurance: Thoroughly reviewed documents",
        "Flexible Plans: Choose a plan that fits your needs"
      ],
      services: [
        "Legal Notices",
        "Civil Suits",
        "Writ Petitions",
        "Special Leave Petitions (SLP)",
        "Written Statements",
        "Rejoinders & Replies",
        "Evidence Affidavits",
        "Divorce Petitions (Contested & Mutual)"
      ]
    }
  ],
  
  corporateStats: [
    { number: "50+", label: "Trained Paralegals" },
    { number: "95%", label: "Client Satisfaction" },
    { number: "60%", label: "Cost Saving" }
  ],
  
  corporateTestimonials: [
    {
      name: "Sarah Mitchell",
      position: "Managing Partner",
      company: "Mitchell & Associates Law Firm",
      text: "JurisGo's LPO services have been transformative for our practice. We've reduced costs significantly while maintaining the highest quality standards. Their paralegals are professional, skilled, and reliable.",
      rating: 5
    },
    {
      name: "David Chen",
      position: "Legal Operations Director",
      company: "TechCorp Legal",
      text: "The corporate training program from JurisGo exceeded our expectations. Our team's productivity increased by 40% within three months. Highly recommended for any corporate legal department.",
      rating: 5
    },
    {
      name: "Jennifer Rodriguez",
      position: "HR Manager",
      company: "Global Enterprises Inc.",
      text: "JurisGo's placement services saved us months of recruitment time. They provided us with highly qualified candidates who integrated seamlessly into our team. Outstanding service!",
      rating: 5
    }
  ],
  
  // Blog posts
  blogPosts: [
    {
      id: "1",
      title: "Understanding Personal Injury Law: A Guide for Aspiring Paralegals",
      excerpt: "Discover the fundamentals of personal injury law and how paralegals play a crucial role in case management and client support.",
      date: "2025-01-20",
      author: "JurisGo Team",
      category: "Personal Injury",
      image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800",
      content: "Full blog content here..."
    },
    {
      id: "2",
      title: "Remote Paralegal Work: Tips for Success",
      excerpt: "Learn essential strategies for thriving as a remote paralegal working with international law firms.",
      date: "2025-01-15",
      author: "JurisGo Team",
      category: "Career Tips",
      image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800",
      content: "Full blog content here..."
    },
    {
      id: "3",
      title: "Workers' Compensation: What Every Paralegal Should Know",
      excerpt: "Comprehensive overview of workers' compensation procedures and the paralegal's role in these cases.",
      date: "2025-01-10",
      author: "JurisGo Team",
      category: "Workers Compensation",
      image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800",
      content: "Full blog content here..."
    }
  ],
  
  hero: {
    title: "Transform Your Legal Career with International Paralegal Training",
    subtitle: "India's Premier Platform for Professional Paralegal Training",
    description: "Structured, practical training for Indian law professionals across multiple legal domains. Build expertise in international legal practice and unlock global opportunities.",
    ctaText: "Explore Programs",
    ctaLink: "/trainings"
  },
  
  about: {
    title: "About JurisGo",
    mission: "Bridging Indian Legal Excellence with Global Opportunities",
    description: "JurisGo is India's first structured international paralegal training platform, dedicated to equipping Indian law students and professionals with practical skills across diverse legal domains. We focus on workflow-based training, not theory, preparing you for real-world legal practice in international contexts.",
    values: [
      {
        title: "Global Standards",
        description: "Training aligned with international legal practice requirements"
      },
      {
        title: "Practical Focus",
        description: "Workflow-based training, not just theoretical knowledge"
      },
      {
        title: "Career Support",
        description: "Placement assistance and verified attorney network access"
      }
    ]
  },
  
  opportunities: {
    title: "Opportunities as an International Paralegal",
    subtitle: "Build a Rewarding Global Legal Career from India",
    income: [
      {
        type: "Monthly Retainers",
        range: "USD 1,500 - 3,500+",
        description: "Consistent income with long-term client relationships"
      },
      {
        type: "Hourly Rates",
        range: "USD 25 - 40",
        description: "Flexible engagement for project-based work"
      },
      {
        type: "Per-Draft Payments",
        range: "USD 50 - 200",
        description: "Payment for specific legal documents and research"
      }
    ],
    workModes: [
      "Fully Remote",
      "Part-Time Options",
      "Full-Time Roles",
      "Flexible Hours"
    ]
  },
  
  trainingPrograms: [
    {
      id: "personal-injury",
      title: "Personal Injury Paralegal Training",
      description: "Master the complete workflow of personal injury cases, from client intake to settlement negotiations and trial preparation.",
      icon: "user-injured",
      duration: "20 Live Sessions",
      level: "Comprehensive",
      instructor: {
        name: "Ms. Delfina Bárcena",
        title: "External Industry Authority",
        subtitle: "Attorney in Argentina & Experienced Personal Injury Paralegal with US Law Firms",
        image: "https://customer-assets.emergentagent.com/job_jurisgo-global/artifacts/oz4609dm_Screenshot%202026-01-25%20at%201.54.47%E2%80%AFPM.png",
        bio: "Ms. Delfina Bárcena brings extensive experience working with prestigious US law firms. She has served as Executive Assistant at Ravan Law (US) and as Bilingual Legal Assistant Specialist- Virtual at Alonso & Alonso Attorneys at Law, PLLC (US). Her expertise in personal injury cases and cross-border legal practice makes her an invaluable mentor for aspiring international paralegals.",
        linkedin: "https://www.linkedin.com/in/delfina-b%C3%A1rcena-a0689b197/"
      },
      highlights: [
        "Case intake and client communication",
        "Medical records review and analysis",
        "Demand letter drafting",
        "Settlement negotiations",
        "Trial preparation and documentation",
        "Insurance claim handling"
      ],
      outcomes: [
        "Handle PI cases independently",
        "Draft professional demand letters",
        "Manage case timelines effectively",
        "Work with U.S. PI law firms"
      ]
    },
    {
      id: "workers-compensation",
      title: "Workers' Compensation Paralegal Training",
      description: "Comprehensive training in workers' compensation law, claims processing, and case management from initial injury to resolution.",
      icon: "hard-hat",
      duration: "20 Live Sessions",
      level: "Comprehensive",
      highlights: [
        "Workers' comp laws and procedures",
        "Claims filing and documentation",
        "Medical provider coordination",
        "Benefit calculations",
        "Hearing preparation",
        "Appeals process management"
      ],
      outcomes: [
        "Process WC claims efficiently",
        "Coordinate with medical providers",
        "Prepare hearing documents",
        "Support U.S. WC attorneys"
      ]
    },
    {
      id: "family-law",
      title: "Family Law Paralegal Training",
      description: "Learn to handle sensitive family law matters including divorce, custody, support, and domestic relations cases with professionalism.",
      icon: "users",
      duration: "20 Live Sessions",
      level: "Comprehensive",
      highlights: [
        "Divorce petition preparation",
        "Child custody agreements",
        "Financial affidavits",
        "Discovery in family cases",
        "Court filing procedures",
        "Client communication skills"
      ],
      outcomes: [
        "Draft family law documents",
        "Handle client interactions sensitively",
        "Manage case documentation",
        "Support family law attorneys"
      ]
    },
    {
      id: "intellectual-property",
      title: "Intellectual Property Paralegal Training",
      description: "Specialized training in IP law covering trademarks, patents, copyrights, and intellectual property portfolio management.",
      icon: "lightbulb",
      duration: "20 Live Sessions",
      level: "Comprehensive",
      highlights: [
        "Trademark search and filing",
        "Patent application support",
        "Copyright registration",
        "IP portfolio management",
        "Infringement monitoring",
        "Licensing agreement review"
      ],
      outcomes: [
        "Conduct trademark searches",
        "Assist in patent filings",
        "Manage IP portfolios",
        "Work with IP law firms globally"
      ]
    }
  ],
  
  training: {
    title: "Our Training Approach",
    subtitle: "Comprehensive Program with Practical Application",
    components: [
      {
        title: "20 Live Sessions",
        description: "Interactive training with experienced legal professionals covering international legal procedures, research methods, and paralegal workflows."
      },
      {
        title: "Study Material & Workbook",
        description: "400+ page comprehensive study material with practical workbook for hands-on learning."
      },
      {
        title: "Capstone Simulation",
        description: "Real-world case simulation to build your professional portfolio and demonstrate competency."
      },
      {
        title: "Certificate of Completion",
        description: "Recognized training completion certificate to showcase your international paralegal credentials."
      },
      {
        title: "Placement Guidance",
        description: "Outreach strategies, verified attorney contacts, and ongoing placement support."
      }
    ]
  },
  
  deliverables: [
    {
      title: "400+ Page Study Material",
      description: "Comprehensive guides covering U.S. legal systems, procedures, and paralegal best practices."
    },
    {
      title: "Practical Workbook",
      description: "Hands-on exercises and templates for real-world application."
    },
    {
      title: "Live Training Sessions",
      description: "20 interactive sessions with Q&A and personalized guidance."
    },
    {
      title: "Capstone Project & Portfolio",
      description: "Build a professional portfolio showcasing your capabilities to potential employers."
    },
    {
      title: "Verified Attorney Contact Database",
      description: "Access to curated list of U.S. attorneys actively hiring remote paralegals."
    },
    {
      title: "Training Certificate",
      description: "Official certificate of completion from JurisGo."
    },
    {
      title: "Placement Assistance",
      description: "Ongoing support for job applications and client outreach."
    }
  ],
  
  targetAudience: [
    {
      title: "Law Students",
      description: "Gain international exposure and practical skills while completing your degree."
    },
    {
      title: "Law Graduates",
      description: "Launch a global career immediately after graduation with USD earning potential."
    },
    {
      title: "Junior Advocates",
      description: "Expand your practice with international clients and diversify income streams."
    },
    {
      title: "Legal Professionals",
      description: "Transition to remote international work with flexible hours and better compensation."
    }
  ],
  
  faqs: [
    {
      question: "Who is eligible for this program?",
      answer: "This program is designed for all law students, law graduates, junior advocates, and legal professionals seeking international paralegal opportunities. No prior paralegal experience is required."
    },
    {
      question: "Do I need a U.S. law license to work as a remote paralegal?",
      answer: "No, you do not need a U.S. law license. Paralegals provide legal support under attorney supervision and do not require bar admission. However, you must complete proper training to understand legal procedures and workflows in your chosen practice area."
    },
    {
      question: "Is this remote work legitimate and legal?",
      answer: "Yes, absolutely. Many international law firms hire remote paralegals for legal research, document drafting, and case management. This is a growing and legitimate practice area, especially post-pandemic, across various legal domains."
    },
    {
      question: "What kind of certificate will I receive?",
      answer: "Upon successful completion of the program, including the capstone project, you will receive a Certificate of Training Completion from JurisGo, demonstrating your competency in U.S. paralegal workflows."
    },
    {
      question: "How is this different from freelancing?",
      answer: "Unlike freelancing, our training prepares you for structured, long-term employment with international law firms, focusing on consistent monthly retainers and professional relationships rather than project-to-project work."
    },
    {
      question: "What is the program structure and duration?",
      answer: "The program consists of 20 live training sessions conducted over 8-10 weeks, along with self-paced study material, practical workbook exercises, and a capstone simulation project."
    },
    {
      question: "Do you guarantee job placement?",
      answer: "While we provide comprehensive placement assistance, verified attorney contacts, and outreach guidance, job placement depends on individual effort and market conditions. We equip you with all necessary tools and support for successful job acquisition."
    },
    {
      question: "What are the payment terms for the program?",
      answer: "Program fees and payment options will be provided during the enrollment process. We offer flexible payment plans to make the training accessible."
    }
  ],
  
  enrollment: {
    title: "Begin Your International Legal Career",
    subtitle: "Limited Seats Available - Next Batch Starting Soon",
    urgency: "Only 30 seats per batch to ensure personalized attention",
    nextBatch: "Next Batch: February 2026",
    ctaText: "Enroll Now",
    features: [
      "Lifetime Access to Study Material",
      "Job Placement Support",
      "Verified Attorney Network",
      "Professional Certificate"
    ]
  },
  
  footer: {
    email: "jurisgo.contact@gmail.com",
    phone: "+91 8130588175",
    address: "8th Floor, Vandana Building, Janpath, New Delhi - 110001",
    social: {
      linkedin: "#",
      twitter: "#",
      instagram: "#"
    },
    disclaimer: "JurisGo provides paralegal training and career guidance. Success in securing employment depends on individual effort, skills, and market conditions. Earning potential figures are indicative based on industry standards and are not guaranteed.",
    copyright: "© 2025 JurisGo. All rights reserved."
  },
  
  // Admin mock data
  adminUser: {
    email: "admin@jurisgo.in",
    password: "deepansh2810",
    name: "Admin User"
  },
  
  enrollments: [
    {
      id: "1",
      name: "Priya Sharma",
      email: "priya.sharma@example.com",
      phone: "+91 98765 43210",
      education: "LLB, 2023",
      date: "2025-01-15",
      status: "Pending"
    },
    {
      id: "2",
      name: "Rahul Mehta",
      email: "rahul.mehta@example.com",
      phone: "+91 98765 43211",
      education: "LLM, 2022",
      date: "2025-01-14",
      status: "Approved"
    },
    {
      id: "3",
      name: "Ananya Iyer",
      email: "ananya.iyer@example.com",
      phone: "+91 98765 43212",
      education: "LLB, Final Year",
      date: "2025-01-13",
      status: "Pending"
    }
  ]
};
